// Example-data mode of Inicio, for local visual review before the backend
// exists. Only the exact string "true" turns it on (fail-closed), and never in
// a production build: `vite build` compiles NODE_ENV to "production", so a
// Vercel deploy can never serve the example tasks even if the variable leaks
// into its environment. `vite.config.js` always defines the variable, so an
// unset one compiles to "".
export const isHumanTasksFixturesMode = () =>
  process.env.REACT_APP_HUMAN_TASKS_FIXTURES === 'true' && process.env.NODE_ENV !== 'production';

export default isHumanTasksFixturesMode;
